module.exports = __webpack_public_path__ + "img/f.37a97c21.jpg";